<template>
    <div :style="{ boxShadow }" class="hk-header">
        <div class="header-container">
            <div class="header-container-left">
                <router-link
                    tag="img"
                    class="logo"
                    :src="logoPng"
                    alt="巴蜀中学"
                    :to="{ name: 'HomePage' }"
                >
                </router-link>
                <p class="welcome">欢迎你来到巴蜀学校，{{ date }}</p>
            </div>
            <input
                v-if="!loginState"
                type="button"
                value="去登录"
                class="to-login"
                @click="toLogin"
            />
            <div v-if="loginState" class="header-container-right">
                <router-link
                    :to="{ name: 'UserCenter' }"
                    class="to-usercenter flex flex-vertical-center"
                >
                    <span class="user-avatar-container">
                        <img
                            :src="userInfo.avatar ? userInfo.avatar : defaultHeader"
                            alt=""
                            class="user-avatar"
                        />
                    </span>
                    <span class="username">{{ userInfo.real_name }}</span>
                </router-link>
                <span class="log-out" @click="handleLogout">退出</span>
            </div>
        </div>
    </div>
</template>

<script>
import moment from '@plugins/_moment';
import { mapGetters } from 'vuex';
import logoPng from '@images/logo.png';
import defaultImg from '@images/base/header-exam.png';
import store from '@store/index';
import { isNotEmpty } from '@helpers/validation';

export default {
    name: 'HkHeader',
    props: {
        boxShadow: {
            type: String,
            default: '0 10px 20px 0 #d9e0e7'
        }
    },
    data() {
        const date = moment();
        return {
            logoPng: logoPng,
            defaultHeader: defaultImg,
            date: date.format('ddd.MM.DD')
        };
    },
    computed: {
        ...mapGetters(['userInfo']),
        loginState() {
            return !!isNotEmpty(store.getters.token);
        }
    },
    methods: {
        handleLogout() {
            this.$store.dispatch('logout', true);
        },
        toLogin() {
            const redirectUrl = this.$route.fullPath;
            this.$router.push({ name: 'Login', query: { redirectUrl: redirectUrl } });
        }
    }
};
</script>
<style lang="scss" scoped>
/* @import url(); 引入css类 */
.hk-header {
    width: 100%;
    min-width: 1200px;
    // box-shadow: 0 10px 20px 0 #d9e0e7;
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    .header-container {
        width: 1200px;
        height: 60px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &-left {
            display: flex;
            align-items: center;
            .logo {
                width: 121px;
                height: 40px;
                margin-right: 18px;
                cursor: pointer;
            }
            .welcome {
                font-size: 14px;
                font-family: 'PingFang SC';
                font-weight: 500;
                color: #333333;
            }
        }
        &-right {
            display: flex;
            align-items: center;
            .to-usercenter {
                text-decoration: none;
                .user-avatar-container {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    margin-right: 10px;
                    overflow: hidden;
                    border: 1px solid #e5e5e5;
                }
                .user-avatar {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                }
            }
            .username:hover {
                color: #7f008f;
            }
            .username,
            .log-out {
                font-size: 14px;
                font-family: 'PingFang SC';
                font-weight: 500;
                color: #333333;
            }
            .log-out {
                margin-left: 8px;
                color: #ec4444;
                cursor: pointer;
            }
        }
        .to-login {
            width: 68px;
            height: 26px;
            border-radius: 13px;
            border: none;
            outline: none;
            background: #7f008f;
            color: #fff;
            font-size: 12px;
            cursor: pointer;
        }
    }
}
</style>
